import React from "react";
import { Form, Input, Radio, Select, Rate, DatePicker } from "antd";
import moment from "moment";
const { MonthPicker } = DatePicker;
const { Option } = Select;
export function FormComponent({
  formItemLayout,
  getFieldDecorator,
  input,
  option,
  showOther,
  onChange,
  onSearch,
  technicalSkills,
  itemData
}) {
  const isEdit = itemData !== null;
  return (
    <Form {...formItemLayout}>
      <Form.Item
        label="Workshop Title (Eg: Android Workshop)"
        className="formsteponeinout"
      >
        {getFieldDecorator("workshopTitle", {
          initialValue: itemData ? itemData.workshopTitle : undefined,
          rules: [
            {
              required: true,
              message: "Please enter workshop name"
            }
          ]
        })(<Input placeholder="Enter workshop name" disabled={isEdit} />)}
      </Form.Item>
      <Form.Item
        label="What skills you have learnt at this workshop?"
        className="formsteponeinout"
      >
        {getFieldDecorator("skillLearntAtWorkshop", {
          initialValue: itemData ? itemData.skillLearntAtWorkshop : undefined,
          rules: [
            {
              required: true,
              message: "List down skills you learnt at this workshop (If your technology name not listed, you can simply type in the field to add it)"
            }
          ]
        })(
          <Select
            mode="tags"
            style={{ width: "100%" }}
            placeholder="Search or Add new technologies"
          >
            {children}
          </Select>
        )}
      </Form.Item>
      <p>(If your technology name not listed, you can simply type in the field to add it)</p>
      <Form.Item className="formsteponeinout" label="Rate this workshop">
        {getFieldDecorator("workshopRate", {
          initialValue: itemData ? itemData.workshopRate : 0.5,
          rules: [
            {
              required: true,
              message: "Rate it"
            }
          ]
        })(
          <Rate
            allowHalf
            tooltips={["Poor", "Average", "Good", "Best", "Excellent"]}
            allowClear={true}
          />
        )}
      </Form.Item>

      <Form.Item
        label="Authority or Company Name organized this workshop"
        className="formsteponeinout"
      >
        {getFieldDecorator("workshopAuthority", {
          initialValue: itemData ? itemData.workshopAuthority : undefined,
          rules: [
            {
              required: true,
              message: "Please enter name of Company/Authority"
            }
          ]
        })(<Input placeholder="Enter name of Company/Authority" />)}
      </Form.Item>

      <Form.Item
        label="Where did you attend this workshop?"
        className="formsteponeinout"
      >
        {getFieldDecorator("workshopWhere", {
          initialValue: itemData ? itemData.workshopWhere : undefined,
          rules: [
            {
              required: true,
              message: "Tell us Where did you attend this workshop?"
            }
          ]
        })(
          <Select
            showSearch
            style={{
              width: 200
            }}
            placeholder="Select"
            optionFilterProp="children"
            onSearch={onSearch}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            <Option value="inCollege">In College</Option>
            <Option value="outSideCollege">Outside College</Option>
          </Select>
        )}
      </Form.Item>

      <Form.Item label="Date of Workshop?(Approx)" className="formsteponeinout">
        {getFieldDecorator("workshopDate", {
          initialValue: itemData
            ? moment(itemData.workshopDate, "MMMM YYYY")
            : undefined,
          rules: [
            {
              required: true,
              message: "Tell us the approx Date of workshop"
            }
          ]
        })(<MonthPicker placeholder="Select month" />)}
      </Form.Item>

      <Form.Item
        label="Do you recommend this workshop to your Juniors/Others?"
        className="formsteponeinout"
      >
        {getFieldDecorator("workshopRecommend", {
          initialValue: itemData ? itemData.workshopRecommend : undefined,
          rules: [
            {
              required: true,
              message: "Please select the answer"
            }
          ]
        })(
          <Radio.Group>
            <Radio value="yes">YES</Radio>
            <Radio value="no">No</Radio>
          </Radio.Group>
        )}
      </Form.Item>
    </Form>
  );
}
const children = [
  <Option key={"C"} value="C">
    C
  </Option>,
  <Option key={"C++"} value="C++">
    C++
  </Option>,
  <Option key={"C#"} value="C#">
    C#
  </Option>,
  <Option key={"Java"} value="Java">
    Java
  </Option>,
  <Option key={"Python"} value="Python">
    Python
  </Option>,
  <Option key={"Javascript"} value="Javascript">
    JavaScript
  </Option>,
  <Option key={"PHP"} value="PHP">
    PHP
  </Option>,
  <Option key={"Swift"} value="Swift">
    Swift
  </Option>,
  <Option key={"Ruby"} value="Ruby">
    Ruby
  </Option>,
  <Option key={"R"} value="R">
    R-Programming
  </Option>,
  <Option key={"VLSI"} value="VLSI">
    VLSI
  </Option>,
  <Option key={"Html"} value="Html">
    HTML
  </Option>,
  <Option key={"CSS"} value="CSS">
    CSS
  </Option>,
  <Option key={"Bootstrap"} value="Bootstrap">
    Bootstrap
  </Option>,
  <Option key={"React"} value="React">
    React
  </Option>,
  <Option key={"AngularJS"} value="AngularJS">
    Angular JS
  </Option>,
  <Option key={"VueJS"} value="VueJS">
    VueJS
  </Option>,
  <Option key={"NodeJS"} value="NodeJS">
    NodeJS
  </Option>,
  <Option key={"Android"} value="Android">
    Android Development
  </Option>,
  <Option key={"IOS"} value="IOS">
    IOS Development
  </Option>,
  <Option key={"HTML"} value="HTML">
    Blockchain
  </Option>,
  <Option key={"ML"} value="ML">
    Machine Learning
  </Option>,
  <Option key={"AI"} value="AI">
    Artificial Intelligence
  </Option>,
  <Option key={"IoT"} value="IoT">
    Internet Of Things
  </Option>,
  <Option key={"Robotics"} value="Robotics">
    Robotics
  </Option>,
  <Option key={"SQL"} value="SQL">
    SQL
  </Option>,
  <Option key={"NoSQL"} value="NoSQL">
    NoSQL
  </Option>,
  <Option key={"CAD"} value="CAD">
    Auto CAD
  </Option>
];
